import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMicrosoftofficeComponent } from './simple-icons-microsoftoffice.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMicrosoftofficeComponent ],
    exports:      [ SimpleIconsMicrosoftofficeComponent ],
    bootstrap:    []
})
export class SimpleIconsMicrosoftofficeModule {}
